// test47
(47 && 0);
